// extracted by mini-css-extract-plugin
module.exports = {"loaderAnimation":"CreateAccount_loaderAnimation__VWmOF","createAccountHeader":"CreateAccount_createAccountHeader__3oQ2P"};